import {Timeout} from "react-number-format/types/types";

export function trackLead(idSha256: string, where: string) {

    //Google
    // @ts-ignore
    if (typeof gtag === 'function') {
        // @ts-ignore
        gtag('event', 'event_action', {
            'event_category': 'conversion',
            'event_label': 'form_submitted',
            'value': 1
        });
    }

    //Facebook
    // @ts-ignore
    if (typeof fbq === 'function') {
        // @ts-ignore
        fbq('track', 'Lead');
    }

    //TikTok
    // @ts-ignore
    if (typeof ttq === 'object') {
        // @ts-ignore
        ttq.identify({
            "external_id": idSha256 // string. A unique ID from the advertiser such as user or external cookie IDs. It must be hashed with SHA256 on the client side.
        });
        // @ts-ignore
        ttq.track('SubmitForm', {
            "content_id": "landingpage", // string. The ID of the page or content that the user interacts with. Example: "homepage".
            "content_name": where, // string. The name of the page or content that the user interacts with. Example: "homepage".
            "value": "1", // number. Value of the order or items sold. Example: 100.
            "currency": "EUR", // string. The 4217 currency code. Example: "USD".
        })
    }
}

export function fireEvent(name: string, callback?: () => void) {

    let callbackTriggered = false;
    let timeout: Timeout = null;

    if (callback) {
         timeout = setTimeout(function () {
            callbackTriggered = true;
            callback();
        }, 3000);
    }

    // @ts-ignore
    if (typeof gtag === 'function') {
        // @ts-ignore
        gtag('event', name, {
            'page': window.location && window.location.pathname ? window.location.pathname : null,
            'hitCallback': function () {
                //console.debug('analytics: event ' + name + ' ' + status);
                if (callback) {

                    if (timeout) {
                        clearTimeout(timeout);
                    }

                    if (!callbackTriggered) {
                        callback();
                    }
                }
            }
        });

        console.log('gtag event ' + name);
    }

    // @ts-ignore
    if (typeof fbq === 'function') {
        // @ts-ignore
        fbq('track', name);
    }

    //TikTok
    // @ts-ignore
    if (typeof ttq === 'object') {
         // @ts-ignore
        ttq.track('Browse', {
            "content_id": "landingpage", // string. The ID of the page or content that the user interacts with. Example: "homepage".
            "content_name": name, // string. The name of the page or content that the user interacts with. Example: "homepage".
        })
    }
}